import { MouseEvent, TouchEvent } from 'react';

export const calculateConstrainedPositions = (
  trimStart: number,
  trimEnd: number,
  maxValue: number,
  minGapPercent: number,
  maxGapPercent: number,
) => {
  let newStartPos = calculatePosition.toPercentage(trimStart, 0, maxValue);
  let newEndPos = calculatePosition.toPercentage(trimEnd, 0, maxValue);

  // Ensure minimum gap while maintaining start position
  if (newEndPos - newStartPos < minGapPercent) {
    newEndPos = newStartPos + minGapPercent;
  }

  // Ensure maximum gap while maintaining start position
  if (maxGapPercent && newEndPos - newStartPos > maxGapPercent) {
    newEndPos = newStartPos + maxGapPercent;
  }

  // Clamp values between 0-100
  newStartPos = clamp(newStartPos, 0, 100);
  newEndPos = clamp(newEndPos, 0, 100);

  return [newStartPos, newEndPos];
};

export const calculatePosition = {
  toPercentage: (value: number, min: number, max: number) => {
    return ((value - min) / (max - min)) * 100;
  },

  fromPercentage: (percent: number, min: number, max: number) =>
    min + (percent / 100) * (max - min),

  fromClientX: (clientX: number, offset: number, trackRect: DOMRect) => {
    const position = clientX - trackRect.left - offset;
    return (position / trackRect.width) * 100;
  },
};

export const calculateValue = {
  fromPosition: (positionPercent: number, maxValue: number): number => {
    return clamp((positionPercent / 100) * maxValue, 0, maxValue);
  },
};

export const clamp = (value: number, min: number, max: number) => {
  return Math.min(Math.max(value, min), max);
};

export type DragStartEvent = MouseEvent | TouchEvent;
export type DragMoveEvent = globalThis.MouseEvent | globalThis.TouchEvent;

export const getClientX = (e: DragStartEvent | DragMoveEvent) => {
  if ('touches' in e) {
    return e.touches[0].clientX;
  }
  return e.clientX;
};
